import React from "react";
import PropTypes from "prop-types";
import {inject, observer} from "mobx-react/index";


// creates a beautiful scrollbar
import { withStyles } from "material-ui";




import '../../assets/css/dashboard.css';
import '../../assets/css/input.css';
import 'react-italy-address-typeahead/dist/styles.css';
import 'react-phone-input-2/lib/style.css'
import GridContainer from "../../components/Grid/GridContainer";
import ItemGrid from "../../components/Grid/ItemGrid";
import CustomInput from "../../components/CustomInput/CustomInput";
import {toJS} from "mobx";
import HeaderCardNew from "../../components/Cards/HeaderCardNew";
import CustomMuted from "../../components/Typography/CustomMuted";
import SweetAlert from "react-bootstrap-sweetalert";
import alertStyle from "../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Button from "../../components/CustomButtons/Button";
import '../../assets/css/configuration.css'

import Cookies from "universal-cookie";

const cookies = new Cookies();


@inject('store')
@observer
class Project extends React.Component {

    constructor (props) {
        super(props)
        this.state = {
            name: this.props.store.appState.name ? this.props.store.appState.name : '',
            phone:this.props.store.appState.phone ? this.props.store.appState.phone: '',
            email:this.props.store.appState.email,
            // new_name: "",
            new_email:"",
            new_email_confirm: "",
            password: "***************",
            user_password: "",
            alertConfirm: false,
            changeEmail: false,
            checked: false,
            loading:true,
            billing_active:false,
            validEmail:true,
            alertMassage: '',
            emailUpdated: '',
            nameState: '',
            phoneState: '',
            emailState: '',
            passwordState: '',
            new_email_state: '',
            new_email_confirm_state: '',


            // projects: this.props.store.appstate.projectList.length > 0 ? this.props.store.appstate.projectList : [],
            project: null,
            projectID: '',
            projectName: '',
            project_type: '',
            emailMerchant: '',
            validProject: false,
            showAlert: false,
            alertMessage: '',
            saveProjectFailedAlert: false,
        };
        this.store = this.props.store.appState;
    };

    componentWillMount(){
        let self = this;
    };

    componentDidMount() {
        document.querySelector('body').scrollTop = 0;
    };

    componentDidUpdate() {

    };

    change = (event, stateName, type) => {
        if(stateName === 'projectID'){
            if (event.target.value !== '' && event.target.value.length > 0) {
                this.setState({ [stateName + "State"]: "success" , projectID:event.target.value});

            } else {
                this.setState({ [stateName + "State"]: "error" , projectID:event.target.value, nameState: ''});

            }
        }
    };

    goToSettings = () => {
        this.props.history.goBack();
    };

    handleCancel = () => {
        this.setState({projectID: "", validProject: false});
        this.props.history.push('/login');
        this.store.logout();

    };


    handleProceed = () => {
        
        const self = this;
        this.store.get_project_merchant({idProject: this.state.projectID}, (res) => {

            if (res.project_name) {
                this.setState({
                    validProject: true,
                    projectName: res.project_name.toUpperCase(),
                    project_type: res.mbu_type_detail,
                    emailMerchant: res.merchant_email,
                });
                cookies.set('project_name',res.project_name.toUpperCase());

            } else if (!res && parseInt(res.code,10) === 10 || parseInt(res.code,10) === 11 || parseInt(res.code,10) === 12) {
                
                this.setState({showAlert: true, validProject: false, alertMessage: res.message.toUpperCase()});
            }
        });
    };

    hideAlert = () => {
        this.setState({projectID: "", validProject: false, showAlert: false});
    };

    hideSaveProjectDataFailedAlert = () => {
        this.setState({saveProjectFailedAlert: false});
    };


    handleConfigProject = () => {
        const self = this;
        
        self.store.project_id = this.state.projectID;
        self.store.project_name = this.state.projectName;
        self.store.project_type = this.state.project_type;
        self.store.merchant_email = this.state.emailMerchant;
        self.store.setProjectID(this.state.projectID);

        let projectData = {};
        projectData.idProject = this.state.projectID;
        projectData.project_name = this.state.projectName;
        projectData.project_type = this.state.project_type;
        projectData.merchant_email = this.state.emailMerchant;
        projectData.lang = '';
        projectData.url = '';
        projectData.sendExcelToRef = '';
        projectData.state = '';
        projectData.landingPageEnabled = '';


        self.store.saveProjectData(projectData, function (result) {
            if (result === true) {

                self.store.look_for_project_data({idProject: self.state.projectID}, (res) => {
                    if(res){
                        // console.log("project has data")
                    }else{
                        // console.log("project does not have data");
                    }
                });
                self.props.history.push({pathname: "/home"});
            } else {
                // console.log("ko");
                self.setState({saveProjectFailedAlert: true});
            }
        });
    }

    handleCancelConfigProject = () => {
        this.setState({projectID: "", validProject: false});
    }



    render() {
        // const {classes, ...rest} = this.props;
        const {classes } = this.props;
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        const { projectID, projectName, validProject, showAlert, alertMessage, saveProjectFailedAlert} = this.state;
        const header_title = DEFAULT_TEXT.prj_title;
        const save_project_data_err_msg  = DEFAULT_TEXT.saveProjectFailed_msg;


        return(
            <div className={classes.content}>
                <GridContainer justify="center">
                    <ItemGrid xs={12} sm={6}  md={4}>
                        <HeaderCardNew
                            // classes={'search-project'}
                            cardTitle={
                                <div className={classes.headerTitle}>
                                    {header_title}
                                </div>
                                }
                            headerColor="rose"
                            cardSubtitle=""
                            content={
                                <div>
                                    <div className={classes.headerSubtitle}>
                                        {/*className={'subtitle'}>*/}

                                        <CustomMuted>
                                            { !validProject ? DEFAULT_TEXT.prj_subtitle : ""}
                                        </CustomMuted>
                                    </div>

                                    <GridContainer>
                                        <ItemGrid xs={12} sm={12} md={12}>
                                            {
                                                !validProject
                                                    ?
                                                        <div>
                                                            <div style={{paddingTop: '35px'}}>
                                                                <CustomInput
                                                                    success={this.state.nameState === "success"}
                                                                    error={this.state.nameState === "error"}
                                                                    labelText=""
                                                                    id="projectID"
                                                                    formControlProps={{
                                                                        fullWidth: true
                                                                    }}
                                                                    inputProps={{
                                                                        type: "number",
                                                                        onChange: event => this.change(event, "projectID", "projectID"),
                                                                        value: this.state.projectID
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{paddingTop: '45px', display: 'flex', justifyContent: 'center'}}>
                                                                <Button 
                                                                    onClick={this.handleCancel}
                                                                >{DEFAULT_TEXT.btn_cancel}
                                                                </Button>
                                                                <Button
                                                                    disabled={!projectID.length>0}
                                                                    style={{marginLeft: '15px'}}
                                                                    color="rose"
                                                                    onClick={this.handleProceed} 
                                                                >{DEFAULT_TEXT.btn_proceed}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    :
                                                        <div>
                                                            <div>
                                                                <h4 className={classes.projectName}>{projectID} - {projectName}</h4>
                                                                <h4 className={classes.projectMsgConfirm}>{DEFAULT_TEXT.prj_confirm_msg}</h4>
                                                            </div>
                                                            <div style={{paddingTop: '45px', display: 'flex', justifyContent: 'center'}}>
                                                                <Button 
                                                                    onClick={this.handleCancelConfigProject}
                                                                >{DEFAULT_TEXT.btn_cancel}</Button>
                                                                <Button
                                                                    style={{marginLeft: '15px'}}
                                                                    color="rose"
                                                                    onClick={() => this.handleConfigProject()}
                                                                >{DEFAULT_TEXT.btn_proceed}
                                                                </Button>
                                                            </div>
                                                        </div>
                                            }
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                            }>
                        </HeaderCardNew>

                        {
                            showAlert ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                warning
                                                confirmBtnText = 'Indietro'
                                                confirmBtnStyle ={{background:'grey'}}
                                                style={{marginLeft: "-240px", marginTop: "-200px"}}
                                                // title={DEFAULT_TEXT.prj_warning_msg.replace(/{{ID}}/g, projectID)}
                                                title={
                                                    <div className={classes.alertMsg}>
                                                        {alertMessage}
                                                    </div>
                                                }
                                                onConfirm={this.hideAlert}
                                                confirmBtnCssClass={ this.props.classes.button + " " + this.props.classes.warning }>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }


                        {
                            saveProjectFailedAlert ?
                                <div>
                                    <GridContainer justify={"center"}>
                                        <ItemGrid xs={12} sm={6}>
                                            <SweetAlert
                                                warning
                                                confirmBtnText = 'Chiudi'
                                                confirmBtnStyle ={{background:'grey'}}
                                                style={{marginLeft: "-240px", marginTop: "-200px"}}
                                                // title={DEFAULT_TEXT.prj_warning_msg.replace(/{{ID}}/g, projectID)}
                                                title={
                                                    <div className={classes.alertMsg}>
                                                        {save_project_data_err_msg}
                                                    </div>
                                                }
                                                onConfirm={this.hideSaveProjectDataFailedAlert}
                                                confirmBtnCssClass={ this.props.classes.button + " " + this.props.classes.warning }>
                                            </SweetAlert>
                                        </ItemGrid>
                                    </GridContainer>
                                </div>
                                :
                                null
                        }

                        {/*{*/}
                        {/*   showMerchantAlert?*/}

                        {/*       <GridContainer justify={"center"}>*/}
                        {/*            <ItemGrid xs={12} sm={6}>*/}
                        {/*                <SweetAlert*/}
                        {/*                    confirmBtnText = 'Indietro'*/}
                        {/*                    warning*/}
                        {/*                    confirmBtnStyle ={{background:'grey'}}*/}
                        {/*                    title={'Attenzione!'  +*/}
                        {/*                    'Il progetto non ha un merchant associato'}*/}
                        {/*                    onConfirm={this.hideAlert}*/}
                        {/*                    onCancel={this.hideAlert}*/}
                        {/*                    confirmBtnCssClass={ this.props.classes.button + " " + this.props.classes.success }>*/}
                        {/*                    /!*{DEFAULT_TEXT.btn_ok}*!/*/}
                        {/*                </SweetAlert>*/}
                        {/*            </ItemGrid>*/}
                        {/*        </GridContainer>*/}

                        {/*        :*/}
                        {/*        null*/}
                        {/*}*/}
                    </ItemGrid>
                </GridContainer>
            </div>
        )
    }
}

Project.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(alertStyle)(Project);



// WEBPACK FOOTER //
// ./src/views/RicercaProgetto/Project.jsx